import React, { useEffect, useState } from 'react';
import { DECK } from '@/constants/testIds';

export default function ScrollProgressBar({ progressRef }) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    let raf;
    const tick = () => {
      setPct(Math.round((progressRef.current || 0) * 1000) / 10);
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => raf && cancelAnimationFrame(raf);
  }, [progressRef]);
  return (
    <div
      data-testid={DECK.scrollProgress}
      className="fixed top-0 left-0 right-0 z-50 h-[2px] bg-black/60"
      aria-hidden="true"
    >
      <div
        className="h-full"
        style={{
          width: `${pct}%`,
          background: 'linear-gradient(90deg, #C8A24A, #E0BD63, #C8A24A)',
          boxShadow: '0 0 16px rgba(200,162,74,0.6)',
          transition: 'width 80ms linear',
        }}
      />
    </div>
  );
}
